import AddCase from "../../components/AddCase";
import DashboardTop from "../../components/Updates/DashboardTop";
import { applyCaseFilters, matchesSearch } from "../../features/cases/caseFilters";
import { FILTER_KEYS } from "../../features/cases/useCaseFilters";
import { ASTIKA_ACTIONS } from "../../features/cases/listActions";
import { ASTIKA_ENDPOINTS } from "../../features/cases/useCaseDetail";
import { truncateCourt } from "../../utils/truncateCourt";
import { ASTIKA_COLUMNS, ASTIKA_COLUMNS_BY_ID } from "../cases/caseColumns";

const COURTS_INFO =
  'Τα δικαστήρια προς χάριν συντομίας εμφανίζονται, όπως εμφανίζονταν προ του Νέου Δικαστικού Χάρτη. Πχ. Το "Πρωτοδικείο Αθηνών (Πρώην Ειρηνοδικείο Αχαρνών)" εμφανίζεται ως "ΕΙΡ. ΑΧΑΡΝΩΝ". Παρακαλώ ελέγξτε ότι σας επιστρέφονται τα σωστά στοιχεία της υπόθεσής σας κατά την εισαγωγή.';

const YES_NO = (yes, no) => [
  { value: "yes", label: yes },
  { value: "no", label: no },
];

const EPAN_OPTIONS = [
  { value: "pending", label: "Χρειάζονται αίτηση" },
  { value: "filed", label: "Κατατέθηκε αίτηση" },
  { value: "application", label: "Αιτήσεις επαναπροσδιορισμού" },
];

const uniqueSorted = (values) =>
  [...new Set(values.filter(Boolean))].sort((a, b) => a.localeCompare(b, "el"));

const getFilterDefs = (rows, filters) => {
  const defs = [
    {
      key: "decisions",
      label: "Απόφαση",
      options: YES_NO("Με απόφαση", "Χωρίς απόφαση"),
    },
    {
      key: "syzitisi",
      label: "Συζήτηση",
      options: YES_NO("Συζητηθείσες", "Μη συζητηθείσες"),
    },
    {
      key: "court",
      label: "Δικαστήριο",
      allLabel: "Όλα",
      options: uniqueSorted(rows.map((c) => c.court)).map((c) => ({
        value: c,
        label: truncateCourt(c),
      })),
    },
    {
      key: "diadikasia",
      label: "Διαδικασία",
      options: uniqueSorted(rows.map((c) => c.diadikasia)).map((d) => ({ value: d, label: d })),
    },
  ];
  if (rows.some((c) => c.epanaprosdiorismos) || filters.epan) {
    defs.push({ key: "epan", label: "Επαναπροσδιορισμός", options: EPAN_OPTIONS });
  }
  return defs;
};

const Overview = ({ rows, onOpen }) => (
  <DashboardTop cases={rows} columns={1} onOpenCase={onOpen} />
);

const AddForm = ({ onClose, onAdded, allCases, credits, setCredits }) => (
  <AddCase
    handleClickAddCaseModal={onClose}
    allCases={allCases}
    handleAddCase={onAdded}
    credits={credits}
    setCredits={setCredits}
  />
);

export const ASTIKA_CONFIG = {
  scope: "astika",
  title: "Αστικά",
  noun: { one: "υπόθεση", many: "υποθέσεις", this: "αυτή την υπόθεση" },
  searchPlaceholder: "Αναζήτηση (ΓΑΚ, δικαστήριο, σημείωση)",
  addLabel: "Νέα υπόθεση",
  columns: ASTIKA_COLUMNS,
  columnsById: ASTIKA_COLUMNS_BY_ID,
  // getRowLabel / renderStatus: CasesTable's Αστικά defaults.
  search: matchesSearch,
  filterKeys: FILTER_KEYS,
  getFilterDefs,
  applyFilters: applyCaseFilters,
  info: COURTS_INFO,
  actions: ASTIKA_ACTIONS,
  bulkRecheck: true,
  noteInPanel: false,
  // Διοικητικά checks share the header's `checking` list.
  pendingFilter: (entry) => entry?.category !== "adj_check",
  refreshOnCheckDone: false, // useCases polls while checks run
  detail: {
    endpoints: ASTIKA_ENDPOINTS,
    fullPageHref: (id) => `/cases/${id}`,
    // title, subtitle, body, document title: CaseDetailPanel's Αστικά defaults.
    renderBody: undefined,
  },
  Overview,
  AddForm,
  modalClass: "ds-modal--addcase",
  afterAdd: { insert: true },
};
